/*
  U = Update
  D = Delete
  G = Get
  A = Add
  C = Check
  S = Send
*/

const GLoanGrade = "/loan/invoice-financing/grade";
const URL_API_GET_TIPE_PINJMAN = (status = "active") => `/products/users/KlikCair?status=${status}`;
const URL_API_GET_TIPE_JAMINAN = (productId) => `/products/${productId}`;
const URL_API_FILE_COLATERAL = (loanId) => `/document/loan/invoice-financing/${loanId}/collateral/invoice`;
const URL_API_FILE_FINANCE_STATEMENT = (loanId) => `/document/loan/invoice-financing/${loanId}/financial-statement`;
const UPass = "/borrower/password";
const ALoan = "/loan/invoice-financing";
const ULoan = (loanCode) => `/loan/invoice-financing/${loanCode}`;
const UResetReqPass = "/borrower/password/reset-request";
const UResetPass = "/borrower/password/reset";
const GLoans = (listStatus) => `/loan/invoice-financing${listStatus}`;
const GDocAgreement = (loanCode) => `/loan/invoice-financing/${loanCode}/document/loan-agreement/generate`;
const GDocAgreementV2 = (loanCode) => `/v2/loan/invoice-financing/${loanCode}/document/loan-agreement/generate`;
const USignLoanAgreement = (loanCode) => `/loan/invoice-financing/${loanCode}/loan-agreement/sign`;
const USignLoanAgreementV2 = (loanCode) => `/v2/loan/invoice-financing/${loanCode}/document/loan-agreement/sign`;
const USignLoanAgreementV3 = (loanCode) => `/v3/loan/invoice-financing/${loanCode}/document/loan-agreement/sign`;
const URjtLoanAgreement = (loanCode) => `/loan/invoice-financing/${loanCode}/borrower/reject`;
const GLoanDetail = (loanCode) => `/loan/invoice-financing/${loanCode}`;
const GVA = (loanCode, VA_TYPE) => `/payment/bni/loan/${loanCode}/virtual-account/${VA_TYPE}`;
const GInfoDoc = (loanCode) => `/document/loan/invoice-financing/${loanCode}/financial-statement`;
const GInfoCollateral = (loanCode) => `/loan/invoice-financing/${loanCode}/collateral`;
const GOfferingHistory = (loanCode) => `/loan/invoice-financing/${loanCode}/offering`;
const GStatusHistory = (loanCode) => `/loan/invoice-financing/${loanCode}/status/history`;
const GMemoHistory = (loanCode) => `/loan/invoice-financing/${loanCode}/memo`;
const SLogin = "/authentication/login";
const SLogout = "/authentication/logout";
const URjtNego = (loanCode) => `/loan/invoice-financing/${loanCode}/reject`;
const UAccNego = (loanCode) => `/loan/invoice-financing/${loanCode}/confirm`;
const UAccNegoV2 = (loanCode) => `/v2/loan/invoice-financing/${loanCode}/confirm`;
const SNego = (loanCode) => `/loan/invoice-financing/${loanCode}/negotiate`;
const GNotif = "/notifications";
const UReadNotif = (NotifID) => `/notifications/${NotifID}/read`;
const GProf = "/borrower/profile";
const URenewToken = "/authentication/token/renew";
const SRegist = "/authentication/registration";
const SVerificationPhone = "/authentication/registration/verification/phone";
const SResendVerification = "/authentication/verification/phone/resend";
const SRegistComplete = "/authentication/registration/complete";
const SResendVerificationEm = "/borrower/verification/email/resend";
const GTransDisbursment = "/loan/invoice-financing/transaction/disbursement";
const GTransRepayment = "/loan/invoice-financing/transaction/repayment";
const GCheckTnC = "/borrower/terms-and-conditions/agreement/check";
const GDetailTnC = (code) => `/borrower/terms-and-conditions/${code}`;
const PCheckTnC = (code) => `/borrower/terms-and-conditions/${code}/agreement`;
const get_user_parameters = "/customer-informations/parameters";

const patch_profile_pic = "/borrower/profile/person-in-charge";
const get_token_cif = "/borrower/customer-informations/auth/token";
const patch_profile_perusahaan = "/customer-informations/corporate/profile";
const post_docs_perusahaan = (docsID) => `/customer-informations/corporate/profile/document/${docsID}`;
const get_bankcodes_params = "/payment/bank-codes";
const patch_bankaccount_borrower = "/borrower/profile/bank-account-data";
const post_submit_profile = "/customer-informations/corporate/profile/submit";
const patch_borrower = "/borrower/profile";

const get_digisign_page = (documentUID, userUID) => `/electronic-signature/digisign/document/${documentUID}/user/${userUID}/sign-page`;
const get_digisign_check = (documentUID) => `/electronic-signature/digisign/document/${documentUID}`;

export {
	GDocAgreement,
	USignLoanAgreement,
	URjtLoanAgreement,
	GLoans,
	URL_API_FILE_FINANCE_STATEMENT,
	UResetPass,
	ALoan,
	ULoan,
	GLoanGrade,
	URL_API_GET_TIPE_PINJMAN,
	URL_API_GET_TIPE_JAMINAN,
	URL_API_FILE_COLATERAL,
	UPass,
	GLoanDetail,
	GVA,
	GInfoDoc,
	GInfoCollateral,
	GOfferingHistory,
	GStatusHistory,
	GMemoHistory,
	SLogin,
	SLogout,
	GProf,
	URenewToken,
	URjtNego,
	UAccNego,
	UAccNegoV2,
	SNego,
	SResendVerificationEm,
	GNotif,
	UReadNotif,
	SRegist,
	SVerificationPhone,
	SResendVerification,
	SRegistComplete,
	GTransDisbursment,
	GTransRepayment,
	UResetReqPass,
	GCheckTnC,
	GDetailTnC,
	PCheckTnC,
	get_user_parameters,
	patch_profile_pic,
	get_token_cif,
	patch_profile_perusahaan,
	post_docs_perusahaan,
	get_bankcodes_params,
	patch_bankaccount_borrower,
	post_submit_profile,
	patch_borrower,
	GDocAgreementV2,
	USignLoanAgreementV2,
	USignLoanAgreementV3,
	get_digisign_page,
	get_digisign_check,
};
